import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Form from "src/components/Form"

const BulkMessageCompose = ({
  message,
  onChange,
  selectedCount,
  validCount,
  invalidCount,
  onNext,
  isLoading,
}) => {
  const hasInvalid = !isLoading && invalidCount > 0
  const allInvalid = !isLoading && validCount === 0

  const renderRecipientInfo = () => {
    if (allInvalid) {
      return (
        <span className="text-red-600">
          None of the {selectedCount} selected{" "}
          {pluralize("recipient", selectedCount)} can receive messages
        </span>
      )
    }

    if (hasInvalid) {
      return (
        <>
          <span className="text-gray-600">
            Sending to{" "}
            <span className="font-semibold text-gray-900">
              {validCount} of {selectedCount}{" "}
              {pluralize("recipient", selectedCount)}
            </span>
          </span>
          <span className="ml-2 text-yellow-700">
            ({invalidCount} cannot receive messages)
          </span>
        </>
      )
    }

    return (
      <span className="text-gray-600">
        Sending to{" "}
        <span className="font-semibold text-gray-900">
          {selectedCount} {pluralize("recipient", selectedCount)}
        </span>
      </span>
    )
  }

  return (
    <div className="space-y-4">
      <div className="text-sm">{renderRecipientInfo()}</div>

      <div>
        <label htmlFor="bulk-message" className="mb-1 block font-medium">
          Message
        </label>
        <Form.Textarea
          id="bulk-message"
          rows={6}
          value={message}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter your message..."
        />
      </div>

      <div className="flex justify-end">
        <Button
          variant="primary"
          onClick={onNext}
          disabled={!message.trim() || isLoading}
        >
          {isLoading ? "Loading recipients..." : "Next"}
        </Button>
      </div>
    </div>
  )
}

BulkMessageCompose.propTypes = {
  message: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedCount: PropTypes.number.isRequired,
  validCount: PropTypes.number,
  invalidCount: PropTypes.number,
  onNext: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

export default BulkMessageCompose
